import { fetcher, REQUEST_URLS } from '@/endpoints/fionaMainApi';
import { PaginatedResult } from '@/types/paginatedResult.interface';
import { PostConfiguration } from '@/types/userProperty.interface';
import useSWR from 'swr';

type FetchMyPropertiesParams = {
  pagination: {
    currentPage: number;
    itemsPerPage: number;
  };
  accountPropertyId?: string | null;
  companyId?: string;
  assignedTo?: string;
};

export const useMyProperties = (queryParams: FetchMyPropertiesParams) => {
  const { pagination, accountPropertyId, companyId, assignedTo } = queryParams;
  const queryFilterAccountPropertyId = accountPropertyId
    ? `&filter.id=$eq:${accountPropertyId}`
    : '';

  const queryFilterCompany = companyId
    ? `&filter.accountProperty.accountPropertyManagementCompanyId=${companyId}`
    : '';

  const queryFilterAssignedTo = assignedTo ? `&filter.assignedTo=$eq:${assignedTo}` : '';
  const myProperties = useSWR<PaginatedResult<PostConfiguration>>(
    REQUEST_URLS.FETCH_MY_PROPERTIES_CONFIGS({
      pagination,
      filterByAccountPropertyId: queryFilterAccountPropertyId,
      filterByCompanyId: queryFilterCompany,
      filterByAssignedTo: queryFilterAssignedTo,
    }),
    fetcher,
    { revalidateOnFocus: false },
  );
  return myProperties;
};
